"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get BudgetSummaryResponse () {
        return BudgetSummaryResponse;
    },
    get CompensationCycleListResponse () {
        return CompensationCycleListResponse;
    },
    get CompensationCycleResponse () {
        return CompensationCycleResponse;
    },
    get CreateCompensationCycleResponse () {
        return CreateCompensationCycleResponse;
    },
    get DeleteCompensationCycleResponse () {
        return DeleteCompensationCycleResponse;
    }
});
const _zod = require("zod");
const BudgetSummaryResponse = _zod.z.object({
    totalAllotment: _zod.z.number(),
    totalProposed: _zod.z.number(),
    totalApproved: _zod.z.number(),
    employeeCount: _zod.z.number(),
    pendingCount: _zod.z.number(),
    inReviewCount: _zod.z.number(),
    approvedCount: _zod.z.number(),
    blockedCount: _zod.z.number()
});
const CompensationCycleResponse = _zod.z.object({
    _id: _zod.z.string(),
    companyId: _zod.z.string(),
    name: _zod.z.string(),
    createdBy: _zod.z.string(),
    createdAt: _zod.z.string(),
    updatedBy: _zod.z.string(),
    updatedAt: _zod.z.string(),
    completedAt: _zod.z.string().nullable(),
    startDate: _zod.z.string(),
    dueDate: _zod.z.string(),
    timezone: _zod.z.string(),
    approvalType: _zod.z.enum([
        "chain",
        "manager"
    ]),
    allotmentMethod: _zod.z.enum([
        "percent_of_payroll",
        "fixed_amount"
    ]),
    allotmentIncrease: _zod.z.number(),
    allotmentIncreasePercent: _zod.z.number(),
    budgetSummary: BudgetSummaryResponse,
    status: _zod.z.enum([
        "active",
        "completed",
        "cancelled"
    ]),
    displayStatus: _zod.z.enum([
        "In Progress",
        "Overdue",
        "Scheduled",
        "Completed",
        "Cancelled"
    ]),
    createdByName: _zod.z.string().optional()
});
const CompensationCycleListResponse = _zod.z.object({
    results: _zod.z.array(CompensationCycleResponse),
    total: _zod.z.number()
});
const CreateCompensationCycleResponse = CompensationCycleResponse;
const DeleteCompensationCycleResponse = _zod.z.object({
    success: _zod.z.boolean()
});
